module.exports = __webpack_public_path__ + "static/media/Elizabeth_B.99516f60.jpg";